var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"action":_vm.action,"id":_vm.id_form,"method":"post","target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":_vm.hidden_input_1,"value":"","id":_vm.hidden_input_1}}),_c('input',{attrs:{"type":"hidden","name":_vm.hidden_input_2,"id":_vm.hidden_input_2},domProps:{"value":_vm.value}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }